import { roundToNearestHundred } from "@/lib/utils.js";

export default {
  props: {
    value: {
      type: Object,
      required: true
    }
  },
  data() {
    return ({
      item: {},
      quantity: 1,
      views: { more: false, quantity: false, summary: false, reviews: false, payment: false },
      liked: false,
      variations: {
        size: null,
      },
      toast: {
        visible: false,
        color: 'orange',
        message: ''
      }
    });
  },
  metaInfo() {
    return {
      title: this.item ? this.item.name : 'Item',
    }
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.item = this.value;
      this.addView();
      this.initCredit();
      this.liked = (JSON.parse(localStorage.getItem('likes')) || []).includes(this.item.id);
    },
    initCredit() {
      this.item.sell_on_credit = 1;
      this.item.no_of_months = 3;
      this.item.credit_price = roundToNearestHundred((0.15 * +this.item.price) + +this.item.price);
      this.item.monthly_amount = roundToNearestHundred(this.item.credit_price / this.item.no_of_months);
    },
    incrementQuantity() {
      if (this.item.quantity === 1) this.showToast('Only one item available', 'orange');
      this.quantity = Math.min((this.item.maximum_order || 10), this.quantity + 1, this.item.quantity || 1)
    },
    decrementQuantity() {
      if (this.item.quantity === 1) this.showToast('Only one item available', 'orange');
      this.quantity = Math.max(1, this.quantity - 1)
    },
    closeReview(l) {
      this.item.total_ratings = l;
      this.views.reviews = false
    },
    async addView() {
      const views = JSON.parse(localStorage.getItem('views')) || [];
      if (!views.includes(this.item.id)) {
        await this.$http.get(`/item/${ this.item.id }/view`);
        views.push(this.item.id);
        localStorage.setItem('views', JSON.stringify(views));
      }
    },
    async addLike() {
      if (!this.liked) {
        const res = await this.$http.get(`/item/${ this.item.id }/like`);
        if (res.data.status === true) {
          const likes = JSON.parse(localStorage.getItem('likes')) || []
          likes.push(this.item.id);
          localStorage.setItem('likes', JSON.stringify(likes))
          this.liked = true;
          this.item.likes++
        }
      }
    },

    variationsSelected() {
      let valid = true;
      if (this.sizes.length && !this.variations.size) {
        this.showToast('Please select a size');
        valid = false;
      }
      return valid;
    },

    showToast(message, color = '') {
      this.toast.visible = true;
      this.toast.message = message;
      if (color) this.toast.color = color
      setTimeout(() => {
        this.toast = { visible: false, message: '', color: '' }
      }, 5000)
    },

    addToCart() {
      if (!this.variationsSelected()) return;
      this.$store.commit('cart/addItem', { ...this.item, unit: this.quantity });
      this.showView();
      this.$emit('close');
      this.$bus.$emit('cart');
    },

    showView(view) {
      Object.keys(this.views).forEach(key => {
        this.views[key] = false
      });
      if (view) this.views[view] = true
    },
  },
  computed: {
    sizes() {
      return (this.item.sizes && this.item.sizes !== 'null') ? this.item.sizes.split(',') : [];
    },
    itemRating() {
      return Math.round(this.item.ratings / this.item.total_ratings)
    },
    price() {
      return (0.15 * +this.item.price) + +this.item.price;
    },
  },
  watch: {
    value() {
      this.init();
      this.quantity = 1;
    }
  }
}
